export interface BreakpointsType {
  xs?: string;
  sm?: string;
  md?: string;
  lg?: string;
  xl?: string;
}

// This order should not be changed under any circumstances
const BREAKPOINTS: BreakpointsType = {
  xs: '320px',
  sm: '568px',
  md: '768px',
  lg: '1024px',
  xl: '1304px',
};

export enum BreakpointKeys {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}
export default BREAKPOINTS;
